/**
 * Floor details when used as a reference in editor tools
 */
export default interface ReferenceFloor {
	id: string;
	level: number;
	name: string;
	current?: boolean;
}

export function referenceFloorToString(floor: ReferenceFloor): string {
	return `${floor.level} - ${floor.name}${floor.current ? " (current)" : ""}`;
}
